<!-- Page « bientôt disponible » commune aux rubriques en préparation (À venir, Questionnaires, Notre volonté).
     Le titre et le texte viennent des props de la route (voir router/index.js). -->
<template>
  <div>
    <Navbar />
    <div class="coming-soon-page">
      <el-card shadow="always" class="coming-soon-card">
        <template #header>
          <h2>{{ title }}</h2>
        </template>
        <el-empty :description="description">
          <el-button type="primary" @click="$router.push('/rubriques')">Retour aux rubriques</el-button>
        </el-empty>
      </el-card>
    </div>
  </div>
</template>

<script>
import Navbar from '@/components/Navbar.vue'

export default {
  name: 'ComingSoon',
  components: {
    Navbar,
  },

  props: {
    title: { type: String, required: true },
    description: { type: String, default: 'Cette rubrique sera bientôt disponible.' },
  },

  mounted() {
    document.body.style.backgroundColor = 'rgba(21, 109, 123)'
  },
}
</script>

<style scoped>
.coming-soon-page {
  padding: 70px 20px 20px;
  max-width: 700px;
  margin: 0 auto;
}

.coming-soon-card h2 {
  margin: 0;
  color: #303133;
}
</style>
